<template>
  <nav
      class="sidebar"
      :class="{'app-dark-theme': !themeStatus}"
  >
    <div class="sidebar-container">
      <div>
        <div class="sidebar-language">
          <language-switcher />
        </div>
        <transition name="fade" mode="out-in">
          <div
              class="sidebar-links"
              v-if="show"
          >
            <div class="sidebar-link-container"
                 v-for="(link, key) in navLanguageLinks"
                 :key="key"
            >
              <router-link
                  class="sidebar-link"
                  :to="link.to"
              >
                {{ link.text }}
              </router-link>
            </div>
          </div>
        </transition>
      </div>
      <div class="theme-switcher">
        <theme-switcher />
      </div>
    </div>
  </nav>
</template>

<script>
import ThemeSwitcher from "./ThemeSwitcher";
import LanguageSwitcher from "./LanguageSwitcher";
import {mapMutations, mapState, mapGetters} from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapState([
      "navStatus",
      "themeStatus",
      "show"
    ]),
    ...mapGetters([
        "navLanguageLinks"
    ])
  },
  methods: {
    ...mapMutations([
      "changeNavStatus"
    ]),
  },
  components: {
    ThemeSwitcher,
    LanguageSwitcher
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.sidebar {
  width: 40%;
  height: 100vh;
  top: 0;
  right: 0;
  background-color: #f1f1f1;
  position: fixed;
  z-index: 10;
  &-language {
    margin-top: 10px;
  }
  &-container {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &-brand {
    height: 30px;
    font-weight: 700;
    display: flex;
    align-items: center;
    font-size: 24px;
  }
  &-links {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
  }
  &-link-container {
    margin-top: 10px;
  }
  &-link {
    font-size: $router-element-size;
  }
}

.theme-switcher {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width : 500px) {
  .sidebar {
    width: 50%;
  }
}

.app-dark-theme {
  background-color: #5a4e4e;
  transition: 0.5s ease all;
}
</style>